import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { createElement } from "react";
/** Render an ordered list of registered section components for a layout name. */
export function Sections({ layout, layoutSections, sections, }) {
    const orderedKeys = layoutSections[layout];
    if (!orderedKeys) {
        return null;
    }
    return (_jsx(_Fragment, { children: orderedKeys.map((key) => {
            const Component = sections[key];
            if (!Component)
                return null;
            return createElement(Component, { key });
        }) }));
}
//# sourceMappingURL=Sections.js.map